import BigNumber from 'bignumber.js';

export const calculateExcessiveAmount = (releaseAmount, balance) => {
  return new BigNumber(releaseAmount)
    .minus(new BigNumber(balance))
    .toNumber();
};